<p class="mat-caption" *ngIf="_notes.length === 0">
    No notes have been recorded.
</p>
<article class="note-item" *ngFor="let note of _notes; trackBy: trackNote">
    <time class="note-date" [attr.datetime]="note.takenAt" *ngIf="note.takenAt">
        {{ note.takenAt | date:'mediumDate' }}
        <small class="note-timeago">{{ note.takenAt | amTimeAgo }}</small>
    </time>
    <p class="note-message">{{ note.message }}</p>
</article>